import type { Messages } from "@erp/i18n";

/** Domain error codes; each one must have a translation under `errors.codes`. */
export type ErrorCode = keyof Messages["errors"]["codes"];

export type HttpErrorKind = "validation" | "unauthorized" | "forbidden" | "notFound" | "conflict" | "rateLimited";

export interface ApiErrorBody {
  error: {
    kind: HttpErrorKind | "domain" | "internal";
    code?: ErrorCode;
    /** Field path → i18n key, for validation errors. */
    fields?: Record<string, string>;
    /** Values a domain error names (`product`: the title of the article that blocks…), untranslated. */
    details?: Record<string, string>;
  };
}

export function isApiErrorBody(value: unknown): value is ApiErrorBody {
  return typeof value === "object" && value !== null && "error" in value && typeof value.error === "object";
}
